import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'


const _hoisted_1 = { class: "inline-block relative text-12px xxl:text-14px w-full" }
const _hoisted_2 = { class: "inline-block relative w-full z-10" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row rounded px-2 bg-gray-lp-200 py-1 mr-2 whitespace-no-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
  fill: "#ABACAE"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row rounded px-2 bg-gray-lp-200 py-1 mr-2 whitespace-no-wrap"
}
const _hoisted_7 = {
  key: 1,
  class: "py-1"
}
const _hoisted_8 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 ml-2" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  class: "w-4",
  alt: "up"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  class: "w-4",
  alt: "down"
}
const _hoisted_11 = { class: "w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md z-20" }
const _hoisted_12 = {
  class: "overflow-auto border-t pt-2",
  style: {"max-height":"155px"}
}
const _hoisted_13 = {
  key: 0,
  class: "pb-2"
}
const _hoisted_14 = {
  key: 1,
  class: "py-4 mb-2 text-gray-lp-300 text-center items-center"
}
const _hoisted_15 = {
  key: 0,
  class: "w-4 mr-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("path", {
  fill: "#B82025",
  d: "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
}, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "w-4 mr-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("path", {
  fill: "#e0e0e0",
  d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
        `w-full ${
          _ctx.isOpenMenu && !_ctx.isDisabled
            ? 'border-l border-t border-r rounded-t'
            : 'border rounded'
        } border-gray-lp-400 text-black-lp-300`
      
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          onClick: _cache[1] || (_cache[1] = () => _ctx.onOpenSelect(!_ctx.isOpenMenu)),
          class: "rounded-md leading-tight px-3 py-2 xxl:py-2.5 pr-8 font-normal cursor-pointer flex flex-row"
        }, [
          (_ctx.modelValue.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    (_ctx.showValue(index, _ctx.modelValue.length))
                      ? (_openBlock(), _createBlock("div", _hoisted_4, [
                          _createVNode("span", null, _toDisplayString(item.name.substring(0, 15) || item), 1),
                          (_openBlock(), _createBlock("svg", {
                            onClick: () => _ctx.onChooseSelect(item),
                            class: "w-4 ml-2",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _hoisted_5
                          ], 8, ["onClick"]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.tagging)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, " +" + _toDisplayString(_ctx.tagging), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.placeholder), 1))
        ]),
        _createVNode("div", _hoisted_8, [
          (_ctx.isOpenMenu)
            ? (_openBlock(), _createBlock("img", _hoisted_9))
            : (_openBlock(), _createBlock("img", _hoisted_10))
        ])
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "18.5rem",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "22.5rem",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "16.5rem",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "20.5rem",
                class: "my-2"
              })
            ]))
          : (
            _ctx.valueSearch ? _ctx.optionsBySearch.length === 0 : _ctx.dataSelect.length === 0
          )
            ? (_openBlock(), _createBlock("div", _hoisted_14, " Apa yang Anda cari tidak ditemukan atau tidak ada. "))
            : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.dataSelect, (item, index) => {
                return (_openBlock(), _createBlock("div", { key: index }, [
                  _createVNode("div", {
                    class: 
              `cursor-pointer flex flex-row items-center px-4 py-1 hover:bg-gray-lp-700 ${index ===
                _ctx.dataSelect.length - 1 && 'pb-2'} ${
                _ctx.isSelected(item) ? 'text-red-lp-100' : 'text-black-lp-200'
              }`
            ,
                    onClick: ($event: any) => (_ctx.onChooseSelect(item))
                  }, [
                    (_ctx.isSelected(item))
                      ? (_openBlock(), _createBlock("svg", _hoisted_15, [
                          _hoisted_16
                        ]))
                      : (_openBlock(), _createBlock("svg", _hoisted_17, [
                          _hoisted_18
                        ])),
                    _createTextVNode(" " + _toDisplayString(item.name || item), 1)
                  ], 10, ["onClick"])
                ]))
              }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.isOpenMenu && !_ctx.isDisabled]
    ])
  ], 512)), [
    [_directive_click_outside, () => _ctx.onOpenSelect(false)]
  ])
}